/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Home_Link_Slug_Manual_HintInputs */

const vi_shop_home_link_slug_manual_hint = /** @type {(inputs: Shop_Home_Link_Slug_Manual_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đường dẫn (slug) của danh mục / nhóm, vd che-tom-non.`)
};

/**

* @param {Shop_Home_Link_Slug_Manual_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_link_slug_manual_hint = /** @type {((inputs?: Shop_Home_Link_Slug_Manual_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_Link_Slug_Manual_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_link_slug_manual_hint(inputs)
});